import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: 'absolute',
      height: 'inherit',
      width: 'inherit',
      overflow: 'hidden',
    },
    root: {
      top: 0,
      left: 0,
      opacity: 1,
      zIndex: 100,
    },
    hidden: {
      opacity: 0,
      transition: 'opacity .2s',
    },
  })
);
